<script lang="ts">
  import EvaluationChartsSection from "../../../../_modules/evaluation-charts-section"

  const props = $props()
</script>

<EvaluationChartsSection {...props} />
